import { FC, useMemo, useState } from 'react';
// import cs from 'classnames';
import styles from './index.module.less';
import Evaluations from './components/Evaluations';
import EvaluationsXTC from './components/EvaluationsXTC';
import Basic from './components/Basic';
import StoreList from './components/StoreList';
import ChanceList from './components/ChanceList';
// import ChancePoint from './components/ChancePoint';
import BussinessStore from './components/BussinessStore';
import Surround from './components/Surround';
import GatherList from './components/GatherList';
import EditableInfo from './components/EditableInfo';
import MallModule from './components/MallModule/index';
import SpotSurveyList from './components/SpotSurveyList';
import AreaMarkingReason from './components/AreaMarkingReason';
import { useTenantCheckInfo } from '@/common/hook/useTenantCheckInfo';
import AI from '@/common/components/business/AIAreaDetailModule';
import { getStorage, removeStorage } from '@lhb/cache';
import { AI_AUTH_KEY, YOUTH_DETAIL_AI_RESULT_CACHE_DATA } from '@/common/components/business/AIAreaDetailModule/ts-config';
import { isArray } from '@lhb/func';
import dayjs from 'dayjs';
import { kaXTC } from '@/ka/xtc/config';
import SimilarBusinessCircle from './components/SimilarBusinessCircle';
// import BusinessStore from './components/BusinessStore'; // 经营门店

/**
 * @Description 选址地图详情-右侧内容区域
 */
const FirstScreenRight: FC<{
  detail,
  overViewData,
  viewChanceDetail,
  chancepointAlias,
  setStoreChecked,
  setSurroundingChecked,
  curDetail,
  setCurDetail,
  storeOptions?,
  setStoreOptions,
  setSurroundingOptions,
  mapIns,
  rangeMarkerRef,
  setIsOpenHeatMap,
  configSwitch,
  gatherList,
  isShare?, // 是否是分享页
  shareParams?,
  editModalData?,
  modelConfigId,
  rangeType,
  isSemirModel,
  isWaitOpen?, // 是否待开业状态
  allowSurroundTitleJumpDetail?: boolean,
  isStartAnalyseOfAI?: boolean; // 是否点击了AI分析
  setIsStartAnalyseOfAI?: any;
  tenantId?: number; // 注意该字段是：登录状态时的租户详情里的租户id
  agentTenant?: any; // 智能体配置
  detailLevel?: number;
}> = ({
  detail,
  overViewData,
  viewChanceDetail,
  chancepointAlias,
  setStoreChecked,
  setSurroundingChecked,
  curDetail,
  setCurDetail,
  storeOptions,
  setStoreOptions,
  setSurroundingOptions,
  mapIns,
  rangeMarkerRef,
  setIsOpenHeatMap,
  configSwitch,
  gatherList,
  isShare = false, // 是否是分享页
  shareParams = {},
  editModalData,
  modelConfigId,
  rangeType,
  isSemirModel = false,
  isWaitOpen = false,
  allowSurroundTitleJumpDetail,
  isStartAnalyseOfAI,
  setIsStartAnalyseOfAI,
  agentTenant,
  tenantId, // 注意该字段是：登录状态时的租户详情里的租户id，不要随便使用
  detailLevel = 0,
}) => {
  const [isAIFailed, setIsAIFailed] = useState<boolean>(false);
  // 生成中的商圈没有数据，不展示该模块

  const { tenantCheckInfo } = useTenantCheckInfo(); // 租户信息;
  const isXTC = kaXTC(tenantCheckInfo); // 使用kaXTC不需要传tenantCheckInfo的，这里是为了兼容历史逻辑
  // 缓存的AI分析商圈的数据
  const targetCacheAIResult = useMemo(() => {
    const cacheData = getStorage(YOUTH_DETAIL_AI_RESULT_CACHE_DATA);
    const { date, data } = cacheData || {};
    // 是否缓存过AI分析的数据
    if (date) {
      // 是否是同一天
      if (dayjs().format('YYYY-MM-DD') === date) {
        if (isArray(data) && data.length) {
          return data.find((item: any) => item.id === detail?.id);
        }
      }
      // 清空缓存
      removeStorage(YOUTH_DETAIL_AI_RESULT_CACHE_DATA);
    }
    return null;
  }, [isStartAnalyseOfAI]);
  // 显示AI模块的时机
  const showAIModule = useMemo(() => {
    // 分享时不展示
    if (isShare) return false;
    // 该租户是否配置了AI智能体
    if (!agentTenant?.agentId) return false;
    // 点击了AI分析 || 已经有缓存的数据了 || 点击了分析但是分析出错了
    return isStartAnalyseOfAI || !!targetCacheAIResult || isAIFailed;
  }, [isShare, isStartAnalyseOfAI, agentTenant?.agentId, targetCacheAIResult, isAIFailed]);

  return (
    <div className={styles.firstScreenRightCon}>
      {/* 不合适标记原因 */}
      {!!detail && <AreaMarkingReason detail={detail} />}

      {/* AI模块 */}
      {
        showAIModule && <AI
          input={`业务场景：场景A-商圈，入参：${JSON.stringify({
            id: detail?.id,
            modelConfigId: modelConfigId,
            tenantId: tenantId,
            authKey: AI_AUTH_KEY
          })}`}
          id={detail?.id}
          extraParams={{
            areaName: detail?.areaName
          }}
          agentTenant={agentTenant}
          isStartAnalyseOfAI={isStartAnalyseOfAI}
          setIsStartAnalyseOfAI={setIsStartAnalyseOfAI}
          targetCacheAIResult={targetCacheAIResult}
          isAIFailed={isAIFailed}
          setIsAIFailed={setIsAIFailed}
        />
      }

      {/* 评分（标准版） */}
      {/* 逻辑同步：src/views/pdf/pages/areareport/components/Overview/index.tsx */}
      {!isWaitOpen && overViewData?.scores?.some(item => item?.score) && !!detail && (isXTC ? <EvaluationsXTC
        resourceMallFlag={detail?.resourceMallFlag}
        overView={overViewData}
        picList={detail?.picList || []}
        configSwitch={configSwitch}
        shareParams={shareParams}
        modelConfigId={modelConfigId}
        detail={detail}
      /> : <Evaluations
        resourceMallFlag={detail?.resourceMallFlag}
        overView={overViewData}
        picList={detail?.picList || []}
        configSwitch={configSwitch}
        shareParams={shareParams}
        modelConfigId={modelConfigId}
        isSemirModel={isSemirModel}
        detail={detail}
      />)}

      <SimilarBusinessCircle
        modelClusterId={detail?.id}
        modelConfigId={modelConfigId}
        configSwitch={configSwitch}
        detailLevel={detailLevel}
        isShare={isShare}
      />

      {/* 商场模块：商场信息、商场客流
        resourceMallFlag 是否源自资源库的商场 */}
      {(!!detail.resourceMallFlag && !isWaitOpen) && <MallModule modelClusterId={detail.id} modelConfigId={modelConfigId} detail={detail} overViewData={overViewData} shareParams={shareParams} />}

      {/* 商圈详情-人口数据及人口热力图 */}
      <Basic
        detail={detail}
        overView={overViewData}
        mapIns={mapIns}
        rangeMarkerRef={rangeMarkerRef}
        rangeType={rangeType}
        setIsOpenHeatMap={setIsOpenHeatMap}
        isShare={isShare}
      />

      {/* 可编辑的开店区域详情备注&附件 */}
      {!isWaitOpen && <EditableInfo detail={editModalData?.data} />}

      {/* 集客点列表 */}
      {(isShare || isWaitOpen) ? null : <GatherList
        gatherList={gatherList}
        clusterId={detail.id}
        detail={detail}
      />}

      {/* 本品牌门店 */}
      <StoreList
        detail={detail}
        viewDetail={viewChanceDetail}
        isShare={isShare}
        noDataPermission
        tenantId={shareParams?.tenantId}
        employeeId={shareParams.employeeId}
      />

      {/* 机会点新 */}
      <ChanceList
        detail={detail}
        viewChanceDetail={viewChanceDetail}
        chancepointAlias={chancepointAlias}
        isShare={isShare}
        tenantId={shareParams?.tenantId}
        employeeId={shareParams.employeeId}
      />
      {/* 机会点 */}
      {/* {
        isShare ? null : <ChancePoint
          detail={detail}
          viewChanceDetail={viewChanceDetail}
          chancepointAlias={chancepointAlias}
        />
      } */}
      {/* 踩点记录 */}
      {isShare ? null : <SpotSurveyList detail={detail} isShare={isShare}/>}
      {/* 新经营门店 */}
      {/* <BusinessStore/> */}
      {/* 经营门店 */}
      {!isWaitOpen && <BussinessStore
        detail={detail}
        setStoreChecked={setStoreChecked}
        storeOptions={storeOptions}
        setStoreOptions={setStoreOptions}
        curDetail={curDetail}
        setCurDetail={setCurDetail}
        isShare={isShare}
        shareParams={shareParams}
        rangeType={rangeType}
      />}
      {/* 周边配套 */}
      <Surround
        detail={detail}
        setSurroundingChecked={setSurroundingChecked}
        setSurroundingOptions={setSurroundingOptions}
        curDetail={curDetail}
        setCurDetail={setCurDetail}
        isShare={isShare}
        shareParams={shareParams}
        modelConfigId={modelConfigId}
        allowSurroundTitleJumpDetail={allowSurroundTitleJumpDetail}
      />
    </div>
  );
};

export default FirstScreenRight;
